import type { INotificationRepository } from '../repositories/INotificationRepository.js';

interface Deps { notificationRepository: INotificationRepository; }

export function createMarkNotificationReadUseCase({ notificationRepository }: Deps) {
  return function markNotificationRead(id: string): Promise<void> {
    return notificationRepository.markRead(id);
  };
}

export function createMarkAllNotificationsReadUseCase({ notificationRepository }: Deps) {
  return function markAllNotificationsRead(projectId?: string): Promise<void> {
    return notificationRepository.markAllRead(projectId);
  };
}

export function createDeleteReadNotificationsUseCase({ notificationRepository }: Deps) {
  return function deleteReadNotifications(): Promise<void> {
    return notificationRepository.deleteRead();
  };
}
